import * as R from 'ramda'

import {
  STANDARD_VALUE,
} from 'containers/Form/RiskValidation/constants'

const isRisk = R.propEq('risk', STANDARD_VALUE)

export default [
  [isRisk, 'Value is Risk.']
]
